import type { IconSvgObject } from './types';

const CaseUpperIcon: IconSvgObject = [
  ["path", { d: "M18.5 7H15V12H18.5C19.8807 12 21 10.8807 21 9.5C21 8.11929 19.8807 7 18.5 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 12H15V17H19.5C20.8807 17 22 15.8807 22 14.5C22 13.1193 20.8807 12 19.5 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 17L7.1857 7.46424C7.07354 7.18385 6.80198 7 6.5 7C6.19802 7 5.92646 7.18385 5.8143 7.46424L2 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3.5 14H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CaseUpperIcon;
